import React from "react";
import Link from "../Link";
import "./NextButton.css"


const NextButton = (props) => {
    const {nextPage} = props;

    return (
        <Link href={nextPage}>
            <button className="next-button">Next</button>
        </Link>
    );
};
export default NextButton;